import {createRoot} from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import {BrowserRouter} from "react-router-dom";
import Providers from "@/store/provider.tsx";

import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
const queryClient = new QueryClient()



createRoot(document.getElementById('root')!).render(
        <QueryClientProvider client={queryClient}>
            <Providers>
                <BrowserRouter basename={import.meta.env.PUBLIC_URL || ''}>
                    <App/>
                </BrowserRouter>
            </Providers>
        </QueryClientProvider>
    ,
)
